import { CommonModule } from '@angular/common';
import { Component,  Input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'sort-icon',
    template: `
<icon *ngIf="up" class="sort-icon" icon="sortup"></icon>
<icon *ngIf="!up" class="sort-icon" icon="sortdown"></icon>
`,
    standalone: true,
    imports: [CommonModule, IconComponent],
})
export class SortIconComponent {
  @Input() up = true
}
